export const videoMxins = {
  data () {
    return {
      languageOptions: [
        {
          "label": "English",
          "value": "EN",
        },
        {
          "label": "French",
          "value": "FR",
        },
        {
          "label": "Spanish",
          "value": "ES",
        },
        {
          "label": "German",
          "value": "DE",
        },
      ],
      videoAccessOptionChoices: [
        {
          "label": "Free",
          "value": "FREE",
        },
        {
          "label": "Premium Members Only",
          "value": "INCLUDED_IN_SUBSCRIPTION",
        },
      ],
    }
  },
  methods: {
    renderLanguage(value) {
      if (value) {
        return this.languageOptions.find((option) => option.value === value).label
      }
      return ''
    }
  }
}